// src/pages/VendorDashboard.jsx
import React from 'react';
import { Navigate } from 'react-router-dom';

const VendorDashboard = () => {
  return <Navigate to="/vendor/overview" replace />;
};

export default VendorDashboard;